import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "Id",
    label: "NO",
    name: "NO",
    sortable: true,
    width: 80
  },
  {
    prop: "FullName",
    name: "FullName",
    label: "Nombre",
    minWidth: 120
    // formatter: ({ FullName }) =>
    //   FullName ?
    //     FullName.length > 100 ?
    //       FullName.substring(0, 100) + "..."
    //       : FullName
    //     : ""
  },
  {
    prop: "From",
    label: "Desde",
    name: "Desde"
  },
  {
    prop: "Email",
    label: "Correo",
    name: "Correo"
  },
  {
    prop: "PhoneNumber",
    label: "Tel.",
    name: "Tel."
  },
  {
    prop: "CreatedAt",
    label: "F. creacion",
    name: "F. creacion",
    formatter: DatetimeFormatter
  }
];
